import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing.space16,
  },
  content: {
    width: "100%",
  },
  name: {
    display: "flex",
    alignItems: "center",
  },
  likeIcon: {
    color: theme.colors.TextSilver,
  },
  icon: {
    padding: theme.spacing.space8,
  },
  loadingText: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
